module.exports = __webpack_public_path__ + "static/media/amr3.4b8824d9.jpg";